export default function ListMedSchema() {
  return (
    <div className="h-[30vh] w-full grid grid-cols-2   gap-4   md:grid-cols-4 lg:grid-cols-6 ">
      {/* <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-gray-900"></div> */}

      <CartSchema />
      <CartSchema />
      <CartSchema />
      <CartSchema />
      <CartSchema />
      <CartSchema />
      <CartSchema />
      <CartSchema />
      <CartSchema />
      <CartSchema />
      <CartSchema />
      <CartSchema />
      <CartSchema />
      <CartSchema />
      <CartSchema />
      <CartSchema />
      <CartSchema />
      <CartSchema />
    </div>
  );
}

function CartSchema() {
  return (
    <div className="flex p-1 gap-2  animate-pulse bg-slate-200 rounded-md  ">
      <div className="flex-[1]">
        <div className="h-8 w-8 rounded-md bg-slate-300" />
      </div>
      <div className="flex w-full flex-col gap-2">
        <div className="w-full h-3 rounded-sm bg-slate-300" />
        <div className="w-full h-3 rounded-sm bg-slate-300" />
      </div>
    </div>
  );
}
